import React from 'react'
import UserCCFeeds from '../settings/automation/UserCCFeeds'

const OrgUserFeeds = () => {
    return (
        <div>
            <UserCCFeeds removeRoundedTop={true} hideAccountNumber={true}/>
        </div>
    )
}

export default OrgUserFeeds
